import { render, staticRenderFns } from "./ShopStocks.vue?vue&type=template&id=6a56f16e&"
import script from "./ShopStocks.vue?vue&type=script&lang=js&"
export * from "./ShopStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports